import { render, staticRenderFns } from "./distincted-table.vue?vue&type=template&id=21686626&"
import script from "./distincted-table.vue?vue&type=script&lang=js&"
export * from "./distincted-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports